import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.89-2-2-2zm0 14H5V8h14v10z"
}), 'WebAssetOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/WebAssetOutlined.js
// module id = 7247
// module chunks = 2